import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button } from '@ipc/ipc-components';
import { Link, useLanguage } from '@ipc/ipc-core';
import { AppContentAdaptive, AppContentTitle } from '../../styles';
import { INVOICE_SEARCH_FORM_DATA } from './constants';
import { FormLabel } from '../../elements';
import { LongInput } from './styles';

const InvoiceInformationSearchCriteria = ({ history: { push }, newWarning }) => {
  const [, language] = useLanguage();
  const [invoiceId, setInvoiceId] = useState('');

  const onInputChange = (e) => {
    setInvoiceId(e.target.value);
  };

  const submitHandler = async (e) => {
    e.preventDefault();

    if (!invoiceId) {
      return newWarning('Please fill the required invoice number field and try again!', 5);
    }
    if (invoiceId.length > 30) {
      return newWarning('The invoice number cannot exceed 30 characters!', 5);
    }
    localStorage.setItem(INVOICE_SEARCH_FORM_DATA, JSON.stringify(invoiceId));
    return push(language(`/invoice/list/?invoiceNumber=${invoiceId}`));
  };

  return (
    <AppContentAdaptive>
      <AppContentTitle>Display Invoice Information</AppContentTitle>
      <form className="Form" onSubmit={submitHandler}>
        <div className="FormRow">
          <FormLabel title="Invoice number" required>
            <LongInput
              value={invoiceId}
              name="invoiceId"
              onChange={onInputChange}
              disableUnderline
              className="Input StyledInput-Big"
              style={{ height: 'auto' }}
            />
          </FormLabel>
        </div>
        <div className="ButtonWrapper">
          <Link to="/pre-settlement/list">
            <Button className="CancelButton">Cancel</Button>
          </Link>
          <Button className="SaveButton" onClick={submitHandler} data-testid="submit-action">Submit</Button>
        </div>
      </form>
    </AppContentAdaptive>
  );
};

InvoiceInformationSearchCriteria.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func,
  }).isRequired,
  newWarning: PropTypes.func,
};

export default InvoiceInformationSearchCriteria;
